export default {
    parts: [
        'accordion',
        'accordionItem',
        'accordionItemSx',
        'accordionButton',
        'headerRow',
        'headerTitle',
        'headerIconCollapsed',
        'headerIconExpanded',
        'accordionPanel',
        'contentText'
    ],
    baseStyle: {
        accordion: {
            mt: 0,
            mb: 4,
            // Flex chain down to the panel so it shrinks (not the CTAs) when space is short
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 1,
            minH: 0
        },
        accordionItem: {
            border: 'none',
            display: 'flex',
            flexDirection: 'column',
            minH: 0
        },
        // Applied via sx so the Collapse wrapper can shrink with the item
        accordionItemSx: {
            '& > .chakra-collapse': {
                minH: 0,
                flexShrink: 1
            }
        },
        accordionButton: {
            variant: 'link',
            textDecoration: 'none',
            px: 0,
            py: 0,
            minH: 'auto'
        },
        headerRow: {
            w: 'full',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        headerTitle: {
            textStyle: 'bodySmRegular',
            textTransform: 'none'
        },
        headerIconCollapsed: {
            boxSize: '24px',
            transition: 'transform 0.2s ease',
            transform: 'rotate(0deg)'
        },
        headerIconExpanded: {
            boxSize: '24px',
            transition: 'transform 0.2s ease',
            transform: 'rotate(180deg)'
        },
        accordionPanel: {
            px: 0,
            pt: 2,
            pb: 0,
            height: '418px',
            maxH: '100%',
            overflowY: 'auto'
        },
        contentText: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textSecondary'
        }
    }
}
